module.exports = __webpack_public_path__ + "img/AirlinesOutlined.bfa4fb60.svg";